var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 27.9999C21.7319 27.9999 27.9999 21.7319 27.9999 14C27.9999 6.26799 21.7319 0 14 0C6.26799 0 0 6.26799 0 14C0 21.7319 6.26799 27.9999 14 27.9999Z",
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5630_18076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 16.041C15.1272 16.041 16.0409 15.1273 16.0409 14.0001C16.0409 12.873 15.1272 11.9592 14 11.9592C12.8728 11.9592 11.9591 12.873 11.9591 14.0001C11.9591 15.1273 12.8728 16.041 14 16.041Z",
    fill: "#3D4756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7508 12.6831C18.9594 11.3943 17.1593 9.23193 14 9.23193C10.8407 9.23193 9.04058 11.3943 8.24922 12.6831C7.75026 13.4901 7.75026 14.5099 8.24922 15.3169C9.04058 16.6058 10.8407 18.7681 14 18.7681C17.1593 18.7681 18.9594 16.6058 19.7508 15.3169C20.2497 14.5099 20.2497 13.4901 19.7508 12.6831ZM14 17.0614C12.3093 17.0614 10.9386 15.6907 10.9386 14C10.9386 12.3093 12.3093 10.9386 14 10.9386C15.6907 10.9386 17.0614 12.3093 17.0614 14C17.0597 15.69 15.69 17.0597 14 17.0614Z",
    fill: "#3D4756"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5630_18076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.25,
    height: 12.25,
    fill: "white",
    transform: "translate(7.875 7.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAction);
export default __webpack_public_path__ + "static/media/viewAction.723e1871109019c8a059aebc93760e1f.svg";
export { ForwardRef as ReactComponent };